import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

type ClientInformationState = {
	newClient: boolean | null;
	firstName: string;
	lastName: string;
	phoneNumber: string;
	email: string;
	zipCode: string;
	clientId: string;
};

type ClientInformationActions = {
	setNewClient: (newClient: boolean) => void;
	setFirstName: (firstName: string) => void;
	setLastName: (lastName: string) => void;
	setPhoneNumber: (phoneNumber: string) => void;
	setEmail: (email: string) => void;
	setZipCode: (zipCode: string) => void;
	setClientId: (clientId: string) => void;
};

const useClientInformationStore = create<ClientInformationState & ClientInformationActions>((set) => ({
	newClient: null,
	setNewClient: (newClient) => set({ newClient }),
	firstName: '',
	setFirstName: (firstName) => set({ firstName }),
	lastName: '',
	setLastName: (lastName) => set({ lastName }),
	phoneNumber: '',
	setPhoneNumber: (phoneNumber) => set({ phoneNumber }),
	email: '',
	setEmail: (email) => set({ email }),
	zipCode: '',
	setZipCode: (zipCode) => set({ zipCode }),
	clientId: '',
	setClientId: (clientId) => set({ clientId }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('useClientInformationStore', useClientInformationStore);
}

export default useClientInformationStore;
